export class agregarDatos {
    public Orden: Number
    public Fecha: string
    public EstadoServicio: string
    public Servicio: string
    public HoraReal: string
    public Pax: string
    public Prov: string
    public Vuelo: string
    public HoraAuto: string
    public HoraRecojo: string
    public Cat: string
    public Nombre: string
    public Area: string
    public Direccion: string
    public Distrito: string
    public Telefono: string
    public Estado: string
    public Com: string
    public Latitud: string
    public Longitud: string
    public idCliente:string
    public idServicio: string
    public Aire :number
    
    //public Area: string;
    public Usuario: string;
    public Centro_Costos: string;
    public Tipo_Servicio: string;
    public Topo_Pago: string;
    public Celular: string;
    public Email: string;
    public MotivoTraslado: string;
    public DirOrigen: string;
    public OrigenLatitud: string;
    public OrigenLongitud: string;
    public DirDestino: string;
    public DestinoLatitud: string;
    public DestinoLongitud: string;
    public Autoriza: string;
    public fechaServicio: string;
    public Hora: string;
    public cantidadPasajeros:string;
    public Producto: string
    public Departamento: string
    public Provincia: string
    public Talla:string
    public Cantidad:string
    public Driver:string
    public Folio: string
    constructor (){
        this.Aire=0
    }
}

export class agregarDatosTaxiFif{
    public Area: string;
    public Usuario: string;
    public Centro_Costos: string;
    public Tipo_Servicio: string;
    public Topo_Pago: string;
    public Celular: string;
    public Email: string;
    public MotivoTraslado: string;
    public DirOrigen: string;
    public DirDestino: string;
    public Autoriza: string;
    public fechaServicio: string;
    public Hora: string;
    constructor (){

    }
}


export class dataConductor{
 public id: number
 public idConductor:string
 public nombreCompleto:string
 public empresa:string
 public local:string
 public activo : boolean
 public FechaCreacion :string
 public dias : any[] = []
 public dia1:JornadaConductor=new JornadaConductor()
 public dia2:JornadaConductor=new JornadaConductor()
 public dia3:JornadaConductor=new JornadaConductor()
 public dia4:JornadaConductor=new JornadaConductor()
 public dia5:JornadaConductor=new JornadaConductor()
 public dia6:JornadaConductor=new JornadaConductor()
 public dia7:JornadaConductor=new JornadaConductor()
 public dia8:JornadaConductor=new JornadaConductor()
}

export class JornadaConductor{
   public idConductor: string
   public idEmpresa: number
   public idSede: number
   public fecha:string
   public inicioJornada:string
   public inicioRefrigerio:string
   public finRefrigerio:string
   public finJornada:string
   public diaSemana:number
   public empresa:string
   public local:string
   public descansa :boolean
   public usuarioModificacion:string
   public idMallaHorariaDiariaConductor:number
   public HoraExtra:string
   public lstTurnos:[]

   constructor(){
     this.descansa=true
     this.usuarioModificacion=""
   }
}

export class DatosConductor {
    public idConductor: string
    public idEmpresa: number
    public empresa: string
    public idSede: number
    public sede: string
    public nombreConductor: string
    public usuarioCreacion: string
    public usuarioModificacion: string
    public activo: boolean
    public dias: any[] = []
    public idMallaHorariaConductor:number
}

export class dataExcelConductor{
    idConductor:string
    conductor:string
    empresa:string
    sede:string
    tipoVehiculo:string
    placa:string
    diasSemana:string
    HoraInicio:string
    HoraFin:string
}